import { TableCell, TableRow } from 'design-system';

import type { FullScreenLegendSeries } from '../fullScreenChartTypes';
import { getLegendSeriesDescription, getLegendValue } from './legend.constants';
import LegendCheckBox from './LegendItem/LegendCheckBox';

interface LegendTableRowProps {
  item: FullScreenLegendSeries;
  onToggleSeries: (seriesId: string) => void;
}

const LegendTableRow = ({ item, onToggleSeries }: LegendTableRowProps) => (
  <TableRow data-series-id={item.id}>
    <TableCell className='w-24'>
      <LegendCheckBox
        name={item.name}
        visible={item.visible}
        onToggle={() => {
          onToggleSeries(item.id);
        }}
      />
    </TableCell>
    <TableCell>
      <div className='flex min-w-0 items-center gap-2'>
        <span
          aria-hidden='true'
          className='h-0.5 w-4 shrink-0'
          style={{ backgroundColor: item.color }}
        />
        <span className='min-w-0'>
          <span className='block truncate font-medium'>{item.name}</span>
          <span className='block truncate text-xs text-muted-foreground'>
            {getLegendSeriesDescription(item)}
          </span>
        </span>
      </div>
    </TableCell>
    <TableCell className='text-right font-mono tabular-nums'>{getLegendValue(item)}</TableCell>
  </TableRow>
);

export default LegendTableRow;
